import { Pressable, Text, View } from 'react-native';
import { styles } from './ReactPocCard.styles';

type ReactPocData = {
  title?: string;
  subtitle?: string;
  branchId?: string;
  count?: number;
  updatedAt?: string;
  onIncrement?: () => void;
};

type ReactPocCardProps = {
  data?: ReactPocData;
};

export default function ReactPocCard({ data = {} }: ReactPocCardProps) {
  const title = data.title ?? 'Expo React POC';
  const subtitle = data.subtitle ?? 'React Native Web component rendered in Angular';
  const branchId = data.branchId ?? 'unknown';
  const count = data.count ?? 0;
  const updatedAt = data.updatedAt ?? 'n/a';

  return (
    <View style={styles.card} testID="room-layout-map-card">
      <Text style={styles.title} testID="room-layout-map-title">
        {title}
      </Text>
      <Text style={styles.subtitle} testID="room-layout-map-subtitle">
        {subtitle}
      </Text>
      <View style={styles.metaRow} testID="room-layout-map-meta">
        <Text style={styles.metaText} testID="room-layout-map-branch">
          Branch: {branchId}
        </Text>
        <Text style={styles.metaText} testID="room-layout-map-count">
          Count: {count}
        </Text>
      </View>
      <Pressable
        onPress={() => {
          if (data.onIncrement) {
            data.onIncrement();
          }
        }}
        style={({ pressed }) => [styles.button, pressed && styles.buttonPressed]}
        testID="room-layout-map-increment"
      >
        <Text style={styles.buttonText}>Increment</Text>
      </Pressable>
      <Text style={styles.timestamp} testID="room-layout-map-updated">
        Updated: {updatedAt}
      </Text>
    </View>
  );
}
